import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
function Banner(props) {
  return (
    <div className="notfound_banner vh-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} className="my-auto text-center">
            <StaticImage
                src="../../images/404.gif"
                alt="Soundly_TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={800}
                height={600}
            />
            <div>
              <Link
                to="/"
                className="border_btn"
                style={{ background: "#f47a1f", color: "#fff" }}
              >
                Back To Home
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
